import OrderDetailPrice from './OrderDetailPrice.styled';

export default OrderDetailPrice;
